import { render, staticRenderFns } from "./LmWidgetsBuilder.vue?vue&type=template&id=124adc6a&"
import script from "./LmWidgetsBuilder.vue?vue&type=script&lang=js&"
export * from "./LmWidgetsBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports